export const ON_RECEIVE_ACCOUNT_INFORMATION = 'ON_RECEIVE_ACCOUNT_INFORMATION';
export const ON_FAIL_ACCOUNT_INFORMATION = 'ON_FAIL_ACCOUNT_INFORMATION';
export const LOADING = 'LOADING_ACCOUNT_INFORMATION';
